require('./bootstrap');

require('alpinejs');

document.getElementById('search').addEventListener('keydown', (e) => {
    const form = document.getElementById('search');
    const active = document.activeElement;
    const results = Array.from(form.getElementsByTagName('a'));
    const index = results.indexOf(active);

    switch (e.key) {
        case "ArrowDown":
            e.preventDefault(); // prevent moving the cursor
            try {
                results[index + 1].focus();
            } catch {
                // Silence
            }
            break;
        case "ArrowUp":
            e.preventDefault(); // prevent moving the cursor
            try {
                results[index - 1].focus();
            } catch {
                // Silence
            }
            break;
      }
});
